const apiURL = import.meta.env.VITE_API_URL || "https://app.artziii.com";

export default apiURL;